export default __webpack_public_path__ + "static/media/Photo 11 - MR - Sans protection.e41e690e.png";